import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Link, Stack } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useProductListerContext } from '../../context';
import { getActiveFilterKey, getFlattenedActiveFilters } from './filtersActive.utils';
import { FiltersActiveItem } from './FiltersActiveItem';
export const FiltersActive = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { updateFilter, removeAllFilters, filterState: { activeFilters }, } = useProductListerContext();
    const flattenedActiveFilters = getFlattenedActiveFilters(activeFilters);
    if (!(!!flattenedActiveFilters && flattenedActiveFilters.length > 0)) {
        return null;
    }
    return (_jsx(Grid.Cell, { display: { xs: 'hidden', lg: 'block' }, order: { xs: 3, lg: 1 }, children: _jsxs(Stack, { gap: "2", align: "center", wrap: "wrap", children: [flattenedActiveFilters.map(activeFilterItem => (_jsx(FiltersActiveItem, { onToggleFilter: updateFilter, activeFilterItem: activeFilterItem }, getActiveFilterKey(activeFilterItem)))), _jsx(Link, { theme: "neutral", variant: "secondary", onClick: removeAllFilters, testId: "clear-all-applied-filters", children: t('product.lister.filter.clear') })] }) }));
};
